module.exports = __webpack_public_path__ + "media/images/flags/16/Botswana-25f01b662abc157a8a1a70eb7f05b870.png";